import { ActionType } from '../../constants/ActionTypes'

export default function affiliatesReducer(state = {}, action) {

    switch (action.type) {

        //Get Affiliates
        case ActionType.GET_AFFILIATE_BEGIN:
            return {
                ...state,
                inProcess: true
            };
        case ActionType.GET_AFFILIATE_SUCCESS:
            return {
                ...state,
                allAffiliates: action.payload.Data,
                inProcess: false
            };
        case ActionType.GET_AFFILIATE_FAILURE:
            return {
                ...state,
                allAffiliates: action.payload.Data,
                inProcess: false
            };

        //Get Project id
        case ActionType.GET_PROJECT_ID_BEGIN:
            return {
                ...state,
                inProcess: true
            };
        case ActionType.GET_PROJECT_ID_SUCCESS:
            return {
                ...state,
                projectId: action.payload.Data,
                inProcess: false
            };
        case ActionType.GET_PROJECT_ID_FAILURE:
            return {
                ...state,
                projectId: action.payload.Data,
                inProcess: false
            };

        //Get Affiliates Info
        case ActionType.GET_AFFILIATE_INFO_BEGIN:
            return {
                ...state,
                inProcess: true
            };
        case ActionType.GET_AFFILIATE_INFO_SUCCESS:
            return {
                ...state,
                affiliatesInfo: action.payload.Data,
                inProcess: false
            };
        case ActionType.GET_AFFILIATE_INFO_FAILURE:
            return {
                ...state,
                affiliatesInfo: action.payload.data,
                inProcess: false
            };

        // SET_SELECTED_TREE_VALUE
        case ActionType.SET_SELECTED_TREE_VALUE:
            return {
                ...state,
                treeValue: action.payload,
            };

        // Add affiliate
        case ActionType.ADD_NEW_AFFILIATE_BEGIN:
            return {
                ...state,
                inProcess: true,
                error: null,
            };

        case ActionType.ADD_NEW_AFFILIATE_SUCCESS:
            return {
                ...state,
                ...action.payload.affiliate,
                inProcess: false
            };

        case ActionType.ADD_NEW_AFFILIATE_FAILURE:
            return {
                ...state,
                inProcess: false,
                newAffiliate: {
                    ...state.newAffiliate,
                },
                error: action.payload.error,
            };

        // Change Affiliate status
        case ActionType.CHANGE_STATUS_BEGIN:
            return {
                ...state,
                inProcess: true
            };

        case ActionType.CHANGE_STATUS_SUCCESS:
            return {
                ...state,
                inProcess: false
            };

        case ActionType.CHANGE_STATUS_FAILURE:
            return {
                ...state,
                inProcess: false
            };

        //Get Permissions
        case ActionType.GET_PERMISSIONS_KEEP_OLD_BEGIN:
            return {
                ...state,
                inProcess: true,
            };
        case ActionType.GET_PERMISSIONS_BEGIN:
            return {
                ...state,
                inProcess: true,
                permissions: []
            };
        case ActionType.GET_PERMISSIONS_SUCCESS:
            return {
                ...state,
                permissions: action.payload.Data,
                inProcess: false
            };
        case ActionType.GET_PERMISSIONS_FAILURE:
            return {
                ...state,
                permissions: action.payload.data,
                inProcess: false
            };

        //Update Permissions
        case ActionType.UPDATE_PERMISSIONS_BEGIN:
            return {
                ...state,
                inProcess: true
            };

        case ActionType.UPDATE_PERMISSIONS_SUCCESS:
            return {
                ...state,
                permissions: action.payload.permissions,
                inProcess: false
            };

        case ActionType.UPDATE_PERMISSIONS_FAILURE:
            return {
                ...state,
                inProcess: false,
                permissions: {
                    ...state.permissions,
                    error: action.payload
                }
            };

        //Get Commissions
        case ActionType.GET_COMMISSIONS_BEGIN:
            return {
                ...state,
                commissions: {},
                inProcess: true
            };
        case ActionType.GET_COMMISSIONS_SUCCESS:
            return {
                ...state,
                commissions: {
                    ...action.payload.Data
                },
                inProcess: false
            };
        case ActionType.GET_COMMISSIONS_FAILURE:
            return {
                ...state,
                commissions: action.payload.Data,
                inProcess: false
            };

        //Update Commissions
        case ActionType.UPDATE_COMMISSIONS_BEGIN:
            return {
                ...state,
                inProcess: true
            };

        case ActionType.UPDATE_COMMISSIONS_SUCCESS:
            return {
                ...state,
                commissions: action.payload.commissions,
                inProcess: false
            };

        case ActionType.UPDATE_COMMISSIONS_FAILURE:
            return {
                ...state,
                inProcess: false,
                commissions: {
                    ...state.commissions,
                    error: action.payload
                }
            };

        // Get User Allowed Affiliates
        case ActionType.GET_USER_ALLOWED_AFFILIATES_BEGIN:
            return {
                ...state,
                inProcess: true,
                mainTreeData: []
            };
        case ActionType.GET_USER_ALLOWED_AFFILIATES_SUCCESS:
            const data = action.payload.data.Data.filter(affilate => !state.allowedSubAff.filter(aff => aff.Key === affilate.Key).length).map(affilate => { return { ...affilate, ParentId: action.payload.parentId } });
            return {
                ...state,
                allowedSubAff: [
                    ...state.allowedSubAff,
                    ...data
                ],
                inProcess: false
            };
        case ActionType.GET_USER_ALLOWED_AFFILIATES_FAILURE:
            return {
                ...state,
                inProcess: false
            };
        case ActionType.SUB_AFFILIATE_ID:
            return {
                ...state,
                affiliateId: action.payload,
            };

        case ActionType.MAIN_AFFILIATE_ID:
            return {
                ...state,
                mainPartnerId: action.payload,
                affiliateId: null,
            };

        // Get Design URL
        case ActionType.GET_DESIGN_BEGIN:
            return {
                ...state,
                inProcess: true
            };
        case ActionType.GET_DESIGN_SUCCESS:
            return {
                ...state,
                designURL: action.payload.Data,
                inProcess: false
            };
        case ActionType.GET_DESIGN_FAILURE:
            return {
                ...state,
                inProcess: false
            };

        case ActionType.SAVE_OPEN_TREE_VALUE:
            return {
                ...state,
                openTreeValue: action.payload
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/mainAffilate/AffiliatesReducer.js